import { CropsState } from "./types";

export default {
  crops: (state: CropsState) => (analysisUuid: string) => state.cropsContext.get(analysisUuid) || [],
  crop: (state: CropsState) => (uuid: string) => Array.from(state.cropsContext.values())
    .flatMap(crops => crops)
    .find(it => it.cropUuid === uuid)
};
